import { useTranslation } from "react-i18next";
import { typography } from "../Typography/styles";
import { cn } from "packages/dsaui/src/utils";

export const fieldLabelClassName = cn("block", typography.formInputLabel.className);
export const fieldLegendClassName = "text-label-sm text-gray-900";
export const fieldDescriptionClassName = "mt-1 mb-0 text-body-sm text-gray-600";
export const fieldErrorClassName = "text-label-sm text-dsa-red";

export const fieldFocusCn = (errorValue?: unknown): string =>
  errorValue
    ? "border-red-700 focus-visible:ring-2 focus-visible:ring-red-300 focus-visible:outline-none"
    : "focus-visible:ring-2 focus-visible:ring-gray-300 focus-visible:outline-none";

export const RequiredMark = ({ required }: { required?: boolean }) => {
  const { t } = useTranslation();
  return required ? <span> ({t("forms.required")})</span> : null;
};

export const FieldErrorMessage = ({
  id,
  children,
  ariaLabel,
  className,
}: React.PropsWithChildren<{ id: string; ariaLabel?: string; className?: string }>) => (
  <div id={id} className={className}>
    <p aria-label={ariaLabel} className={fieldErrorClassName}>
      {children}
    </p>
  </div>
);
